import { GASTOS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default function gastosReducer(state = initialState, action) {
    switch (action.type) {
        case GASTOS.BUSCAR:
            return { ...state, listado: action.payload };

        case GASTOS.AGREGAR:
            return { ...state, listado: [action.payload, ...state.listado] };

        case GASTOS.AGREGAR_MULTIPLE:
            return { ...state, listado: [...action.payload, ...state.listado] };

        case GASTOS.EDITAR:
            return {
                ...state,
                listado: state.listado.map(gasto =>
                    gasto._id === action.payload._id ? action.payload : gasto
                )
            };

        case GASTOS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(gasto => gasto._id !== action.payload)
            };

        case GASTOS.DETALLES:
            return { ...state, detalles: action.payload };

        case GASTOS.LIMPIAR:
            return { ...state, detalles: null };

        default:
            return state;
    }
}
